var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDashboard = function SvgDashboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M341.333 796.444H227.555V398.222h113.778zm227.556 0H455.111V227.555h113.778zm227.555 0H682.666V568.888h113.778zm113.778 113.778H113.778V113.778h796.444zm0-910.222H113.778C51.2 0 0 51.2 0 113.778v796.444C0 972.8 51.2 1024 113.778 1024h796.444C972.8 1024 1024 972.8 1024 910.222V113.778C1024 51.2 972.8 0 910.222 0"
  })));
};
export default SvgDashboard;